import React, { Component } from 'react';
import AgentTeamSelect from 'components/AgentTeamSelect';
import GeckoRequest from 'services/gecko-request';
import { connect } from 'react-redux';
import { showContactDetails } from '../../../../actions/ui';
import {
  GeckoAvatar,
  GeckoDialogService,
  TooltipIdStr,
  Tooltip,
  OverlayTrigger,
} from 'ui';
import { fetchContact } from '../../actions';
import * as utils from '../../utils';
import GeckoFeatures from 'services/gecko-features';

export class ConversationHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAgentSelectHidden: true,
    };

    this.clickToAssignTooltipTarget1 = React.createRef();
    this.clickToAssignTooltipTarget2 = React.createRef();
  }

  componentDidMount() {
    if (!this.props.contact && !this.props.fetchingContact) {
      fetchContact(this.props.contactId);
    }
  }

  componentDidUpdate() {
    if (!this.props.contact && !this.props.fetchingContact) {
      fetchContact(this.props.contact_id);
    }
  }

  renderContactPanelButton() {
    return (
      <>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 0, hide: 0 }}
          overlay={
            <Tooltip id={'contact-panel-tip'}>
              {this.props.contactDetailsOpen
                ? 'Close Contact details'
                : 'Open Contact details'}
            </Tooltip>
          }
        >
          <span
            className="fa-stack fa-lg d-none d-xl-inline-flex ml-3 btn btn-outline-primary icon-only gecko-btn"
            ref={(target) => (this.contactTooltipTarget = target)}
          >
            <i
              className={`far fa-columns fa-stack-1x`}
              id={'contact-panel-tip'}
              onClick={this.props.toggleContactDetails}
            ></i>
          </span>
        </OverlayTrigger>
      </>
    );
  }

  renderSmallScreenContactButton() {
    return (
      <>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 0, hide: 0 }}
          overlay={<Tooltip id={'contact-panel-sml-tip'}>View Contact</Tooltip>}
        >
          <span
            className="fa-stack fa-lg d-xl-none btn btn-outline-primary icon-only gecko-btn"
            ref={(target) => (this.viewContactToolTipTarget = target)}
          >
            <i
              className="far fa-id-badge fa-stack-1x"
              onClick={() => {
                this.props.showContactDetails();
              }}
              id={'contact-panel-sml-tip'}
            ></i>
          </span>
        </OverlayTrigger>
      </>
    );
  }

  renderDeleteConversationButton() {
    return this.props.conversation.status === 'closed' ? (
      <>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 0, hide: 0 }}
          overlay={<Tooltip id={'delete-icon-tip'}>Delete</Tooltip>}
        >
          <span
            className="fa-stack fa-lg clickable btn btn-outline-primary icon-only gecko-btn"
            ref={(target) => (this.secondaryTooltipTarget = target)}
            id="clickable"
          >
            <i
              className="far fa-trash-alt fa-stack-1x"
              onClick={() =>
                this.props.deleteConversation(this.props.conversation)
              }
              id={'delete-icon-tip'}
            ></i>
          </span>
        </OverlayTrigger>
      </>
    ) : null;
  }

  renderConversationStateChangeButton() {
    return (
      <>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 0, hide: 0 }}
          overlay={
            <Tooltip id={'render-convo-tip'}>
              {this.props.conversation.status === 'closed' ? 'Reopen' : 'Close'}
            </Tooltip>
          }
        >
          <span
            className="fa-stack fa-lg btn btn-outline-primary icon-only gecko-btn"
            ref={(target) => (this.primaryTooltipTarget = target)}
          >
            <i
              className={`far fa-${
                this.props.conversation.status === 'closed'
                  ? 'unlock-alt'
                  : 'check'
              } fa-stack-1x`}
              onClick={this.changeConversationStatus}
              id={'render-convo-tip'}
            ></i>
          </span>
        </OverlayTrigger>
      </>
    );
  }

  renderHeaderButtons() {
    return (
      <span className="conversation-handler-btns">
        {this.renderConversationStateChangeButton()}
        {this.renderDeleteConversationButton()}
        {this.renderSmallScreenContactButton()}
        {this.renderContactPanelButton()}
      </span>
    );
  }

  focusAssignedSelect() {
    this.setState({
      isAgentSelectHidden: !this.state.isAgentSelectHidden,
    });
    if (this.state.isAgentSelectHidden) {
      document.addEventListener('mousedown', this.handleClick, false);
      this.assignedSelect.focus();
    } else {
      document.removeEventListener('mousedown', this.handleClick, false);
    }
  }

  handleClick = (e) => {
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.setState({
      isAgentSelectHidden: true,
    });
  };

  changeConversationStatus = () => {
    this.props.conversation.status === 'closed'
      ? this.props.changeConversationStatus('open', this.props.conversation)
      : this.props.changeConversationStatus('closed', this.props.conversation);
  };

  renderSelector() {
    const addTeam = (team_id) => {
      GeckoRequest.post(`/conversation/${this.props.conversation.id}/assign`, {
        team_id,
      });
    };
    const removeTeam = (team_id) => {
      return GeckoRequest.post(
        `/conversation/${this.props.conversation.id}/unassign`,
        { team_id: Number(team_id) }
      );
    };

    const addAgent = (agent_id) => {
      GeckoRequest.post(`/conversation/${this.props.conversation.id}/assign`, {
        agent_id,
      });
    };
    const removeAgent = (agent_id) => {
      return GeckoRequest.post(
        `/conversation/${this.props.conversation.id}/unassign`,
        { agent_id: Number(agent_id) }
      );
    };

    let value = [].concat(
      this.props.conversation.teams
        .filter((t) => t != null)
        .map((team) => `team_${team.id}`),
      this.props.conversation.agents
        .filter((a) => a != null)
        .map((agent) => `agent_${agent.id}`)
    );

    // removes duplicates if workflows add agent/team in multiple times
    value = Object.keys(
      value.reduce((accumulator, item) => {
        return Object.assign({}, accumulator, { [item]: null });
      }, {})
    );

    const getDiff = (oldValue, newValue) => {
      const added = newValue.filter((val) => !oldValue.includes(val));
      const removed = oldValue.filter((val) => !newValue.includes(val));
      return [added, removed];
    };

    const isAgentAssigned = (assignments) => {
      const assignmentsToAgent = [
        `agent_${this.props.agentId}`,
        ...this.props.agentsTeamIds.map((teamId) => `team_${teamId}`),
      ];
      return assignments.some((assignment) =>
        assignmentsToAgent.includes(assignment)
      );
    };

    const wasAgentAssigned = () => {
      return value.includes(`agent_${this.props.agentId}`);
    };

    const wasAgentsTeamAssgined = () => {
      return this.props.agentsTeamIds.some((teamId) =>
        value.includes(`team_${teamId}`)
      );
    };

    const showWarningForRestrictedView = (assignments) =>
      !isAgentAssigned(assignments) && this.props.hasRestrictedConversationView;

    const showWarningForTeamAssignment = (assignments) => {
      const canTeamChannel = GeckoFeatures.can('team-channels');
      const { myChannel, global } = isMyChannel();
      const amIAssigned = isAgentAssigned(assignments);
      const wasIAssigned = wasAgentAssigned();
      const wasMyTeamAssigned = wasAgentsTeamAssgined();

      return (
        canTeamChannel &&
        (!myChannel || !global) &&
        !amIAssigned &&
        (wasIAssigned || wasMyTeamAssigned)
      );
    };

    const isMyChannel = () => {
      const conversationChannelId =
        this.props.conversation.last_message_channel;
      const channel = this.props.channels.find(
        (channel) => channel.id === conversationChannelId
      );

      if (!channel) {
        return false;
      }

      const intersection = channel.assigned_team_ids.filter((value) =>
        this.props.agentsTeamIds?.includes(value)
      );

      const global = channel.assigned_team_ids.length === 0;

      return { myChannel: intersection.length !== 0, global };
    };

    const confirmAssignments = (assignments) => {
      if (
        showWarningForRestrictedView(assignments) ||
        showWarningForTeamAssignment(assignments)
      ) {
        return new GeckoDialogService().confirm(
          'You will no longer be able to see this conversation if your assignment is removed from the conversation.'
        );
      }
      return Promise.resolve(true);
    };

    const updateAssigned = (newValue) => {
      return confirmAssignments(newValue).then((confirmed) => {
        if (!confirmed) {
          return;
        }
        const [added, removed] = getDiff(value, newValue);
        added.forEach((item) => {
          const isAgent = item.indexOf('agent_') === 0;
          if (isAgent) {
            addAgent(item.replace('agent_', ''));
          } else {
            addTeam(item.replace('team_', ''));
          }
        });
        removed.forEach((item) => {
          const isAgent = item.indexOf('agent_') === 0;
          if (isAgent) {
            removeAgent(item.replace('agent_', ''));
          } else {
            removeTeam(item.replace('team_', ''));
          }
        });
      });
    };

    let agentTeamSelectClass = this.state.isAgentSelectHidden
      ? 'agentTeamSelectHidden'
      : '';

    if (value.length === 0) {
      return (
        <div id="conversationAgentsHeader" className="clearfix">
          <div
            className="conversation-control-header-assigned"
            ref={(node) => (this.node = node)}
          >
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 0, hide: 0 }}
              overlay={
                <Tooltip id={'click-to-assign-tip'}>Click to assign</Tooltip>
              }
            >
              <span
                ref={this.clickToAssignTooltipTarget1}
                className="text-right create-selector-toggle clickable"
                onClick={this.focusAssignedSelect.bind(this)}
                id={'click-to-assign-tip'}
              >
                Assign to <i className="far fa-angle-down"></i>
              </span>
            </OverlayTrigger>
            <AgentTeamSelect
              specialClass={agentTeamSelectClass}
              value={value}
              onChange={updateAssigned}
              agentSeperatorLabel="Assign to Agent"
              teamSeperatorLabel="Assign to Team"
              selectProps={{
                autoFocus: true,
                openOnFocus: true,
                clearable: false,
                ref: (elem) => (this.assignedSelect = elem),
              }}
            />
          </div>
        </div>
      );
    }

    let keyAgent = '';
    let keyAgents = [];

    this.props.conversation.agents.forEach(function (agent) {
      if (!agent) {
        return;
      }
      `agent_${agent.id}` === value[0]
        ? (keyAgent = agent)
        : keyAgents.push(agent.full_name);
    });
    this.props.conversation.teams.forEach(function (team) {
      if (!team) {
        return;
      }
      `team_${team.id}` === value[0]
        ? (keyAgent = team)
        : keyAgents.push(team.name);
    });

    const keyAgentsLength = keyAgents.length;
    keyAgents = keyAgents.join(', ');

    let numOtherAgents = '';
    if (value.length > 2) {
      numOtherAgents = ` + ${keyAgentsLength} others`;
    } else if (value.length === 2) {
      numOtherAgents = ` + ${keyAgentsLength} other`;
    }

    return (
      <div id="conversationAgentsHeader" className="clearfix">
        <div
          className="conversation-control-header-assigned clickable"
          ref={(node) => (this.node = node)}
        >
          <span
            id={`${keyAgent.id}-name`}
            className="gecko-header-avatar"
            onClick={this.focusAssignedSelect.bind(this)}
          >
            <GeckoAvatar
              name={keyAgent.full_name ? keyAgent.full_name : keyAgent.name}
              first_name={keyAgent.first_name ? keyAgent.first_name : ''}
              last_name={keyAgent.last_name ? keyAgent.last_name : ''}
              color={
                keyAgent.additional ? keyAgent.additional.avatar_colour : ''
              }
              bgImage={
                keyAgent.additional
                  ? keyAgent.additional.profile_picture_url
                  : ''
              }
            />
            {keyAgent.full_name ? keyAgent.full_name : keyAgent.name}
          </span>
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 0, hide: 0 }}
            overlay={
              <Tooltip id={'contact-panel-tip'}>
                {keyAgents.length > 1 ? keyAgents : 'Click to assign'}
              </Tooltip>
            }
          >
            <span
              ref={this.clickToAssignTooltipTarget2}
              className="text-right create-selector-toggle"
              onClick={this.focusAssignedSelect.bind(this)}
              id={'contact-panel-tip'}
            >
              {numOtherAgents} <i className="far fa-angle-down"></i>
            </span>
          </OverlayTrigger>
          <AgentTeamSelect
            specialClass={agentTeamSelectClass}
            value={value}
            onChange={updateAssigned}
            agentSeperatorLabel="Assign to Agent"
            teamSeperatorLabel="Assign to Team"
            selectProps={{
              autoFocus: true,
              openOnFocus: true,
              clearable: false,
              ref: (elem) => (this.assignedSelect = elem),
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    const userName = this.props.contact ? this.props.contact.full_name : '';

    const subjectLine = utils.getSubjectLineIfEmail(
      this.props.conversation,
      this.props.channels
    );
    const emailClass = subjectLine ? 'conversation-control-header-email' : '';
    return (
      <div className={`row conversation-control-header ${emailClass}`}>
        <div className="headerLeft">
          <span className="conversation-name">{userName}</span>
          {subjectLine && (
            <>
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 0, hide: 0 }}
                overlay={
                  <Tooltip
                    id={`${TooltipIdStr(
                      this.props.conversation.id
                    )}-conversation-subject`}
                  >
                    Subject: {subjectLine}
                  </Tooltip>
                }
              >
                <div
                  id={`${TooltipIdStr(
                    this.props.conversation.id
                  )}-conversation-subject`}
                  className="conversation-subject"
                >
                  Subject: {subjectLine}
                </div>
              </OverlayTrigger>
            </>
          )}
        </div>
        <div className="headerRight">
          <div className="conversation-agent">{this.renderSelector()}</div>
          <div>{this.renderHeaderButtons()}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const loggedInUser = state.appState.loggedInUser;
  return {
    contact: state.conversationsRoute.contactsById[props.conversation.user_id],
    agentId: loggedInUser.id,
    channels: state.channels,
    hasRestrictedConversationView:
      loggedInUser.permissions &&
      loggedInUser.permissions.restrict_conversations,
    agentsTeamIds: state.agent_teams
      .filter((agentTeam) => agentTeam.agent_id === loggedInUser.id)
      .map((agentTeam) => agentTeam.team_id),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showContactDetails: () => {
      dispatch(showContactDetails());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConversationHeader);
